const dashboard = {
	title: "Dashboard",
	no_upcoming_course: "Ingen kurs er satt opp",
	duration: "Varighet",
	enrolled: "Påmeldte",
	students: "Deltagere",
};
export default dashboard;